import produce from "immer"
import { mountStoreDevtool } from "simple-zustand-devtools"
import create from "zustand"

type SchedulingStore = {
  showGenerateDialog: boolean
  showAddScheduleDialog: boolean
  setShowGenerateDialog: (showGenerateDialog: boolean) => void
  setShowAddScheduleDialog: (show: boolean) => void
}
const useSchedulingStore = create<SchedulingStore>(set => ({
  showGenerateDialog: false,
  showAddScheduleDialog: false,
  setShowGenerateDialog(showGenerateDialog) {
    set(
      produce<SchedulingStore>(store => {
        store.showGenerateDialog = showGenerateDialog
      })
    )
  },
  setShowAddScheduleDialog(showAddScheduleDialog) {
    set(
      produce<SchedulingStore>(store => {
        store.showAddScheduleDialog = showAddScheduleDialog
      })
    )
  },
}))
if (process.env.NODE_ENV === "development") {
  mountStoreDevtool("SchedulingStore", useSchedulingStore)
}
export default useSchedulingStore
